/**
 * StagePlotThumb — compact visual thumbnail of a stage plot for list cards.
 *
 * Renders the canonical SVG (via stagePlotToSvg) inline in the DOM. Inline
 * (not <img>) so any `/stageplot-assets/*.png` referenced by composite
 * drumkit/riser/spd graphics can still load external resources, which an
 * <img>-embedded SVG's "secure static mode" forbids.
 */
import { useMemo } from 'react';
import type { StagePlot } from '../../shared/types/stageplot';
import { normalizePlot, stagePlotToSvg } from './StagePlotCanvas';

interface StagePlotThumbProps {
  plot: StagePlot;
  /** When true, adds the `.selected` modifier class (accent outline) for gallery highlighting. */
  selected?: boolean;
}

export default function StagePlotThumb({ plot, selected = false }: StagePlotThumbProps) {
  const np = useMemo(() => normalizePlot(plot), [plot]);
  const svg = useMemo(() => stagePlotToSvg(np), [np]);

  const cls = selected ? 'stageplot-thumb selected' : 'stageplot-thumb';

  return (
    <div className={cls}>
      <div className="stageplot-thumb-inner" dangerouslySetInnerHTML={{ __html: svg }} />
    </div>
  );
}
